import { Injectable } from '@angular/core';
import { ModelModalReturnValue } from '@models-global/model-modal-return-value';
import { ClaimReportModalComponent } from '@module-claims/components/claim-report-modal/claim-report-modal.component';
import { StateClaimModal } from '@module-claims/store/claims-modal.state';
import { ReportType } from '@module-report/enums/report-type.enum';
import { Select } from '@ngxs/store';
import { DialogService } from '@progress/kendo-angular-dialog';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClaimsModalService {
  @Select('StateClaimModal')
  stateClaimModal$!: Observable<StateClaimModal>;

  constructor(private _dialogService: DialogService) {}

  open(): Observable<ModelModalReturnValue<ReportType>> {
    const modalRef = this._dialogService.open({
      title: 'Reports',
      content: ClaimReportModalComponent,
      width: 400
    });

    const data$ = new Subject<ModelModalReturnValue<ReportType>>();

    this.stateClaimModal$.subscribe((data) => {
      data$.next({ action: data.action, data: data.value, modalRef });
    });

    return data$;
  }
}
